import assistentAPI from "apis/AssistentAPI";

export const getAll = async ({ dateRange, query }) => {
  let response = await assistentAPI.questions({
    ini: dateRange.startDate,
    fin: dateRange.endDate,
    size: query.limit,
    page: query.page
  });

  response.items = response.items.map((item) => ({
    GUID: item.id,
    ...item
  }));
  
  return {
    data: response.items,
    count: response.meta.totalItems
  }
};